import axios from '@/libs/api.request.js'

// 获取首页数据
export const getVideoHomeData = (id) => {
  return axios.request({
    url: '/Video/GetHomeData',
    params: { id },
    method: 'get'
  })
}

export const getPageList = (page, pageSize, data) => {
  return axios.request({
    url: '/Video/GetPageList',
    params: {
      page,
      pageSize
    },
    data,
    method: 'post'
  })
}

export const getDetail = (id) => {
  return axios.request({
    url: '/Video/GetDetail',
    params: { id },
    method: 'get'
  })
}

export const getPolyToken = (vid) => {
  return axios.request({
    url: '/Video/GetPolyToken',
    params: { vid },
    method: 'get'
  })
}


// WEBPACK FOOTER //
// ./src/api/video.js